import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddincidenttypepopupComponent } from '../../generalpopup/addincidenttypepopup/addincidenttypepopup.component';
import { HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';

@Component({
  selector: 'app-addincident',
  templateUrl: './addincident.component.html',
  styleUrls: ['./addincident.component.css']
})
export class AddincidentComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "Incident";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isincidenttypeaddmode: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  ismanualclose: boolean;
  isemploading: boolean = false;
  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  filterincidenttypeid: any = null;
  filterincidenttypename: any = null;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;
  //Edit Get Values
  incidentColl: any = [];
  incidentBO: any = {};

  incidentid: number = 0

  incidenttypeColl: any = [];
  empColl: any = [];
  empBO: any = {}

  incidentform = new FormGroup({
    incidentid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    incidenttypeid: new FormControl(null, Validators.required),
    transdt: new FormControl(null, Validators.required),
    descr: new FormControl(''),
    actiontaken: new FormControl(''),
    actiontakenby: new FormControl(null),
    actiontakenon: new FormControl(null),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.incidentid = params.id
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
      if (params.incidenttypename !== undefined) {
        this.filterincidenttypename = params.incidenttypename
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }
    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.incidentform.reset();
      this.fnInitializeFormGroup();

      if (this.incidentid > 0) {
        this.fngetIncident();
      }
      this.fngetIncidentType();
      this.fngetEmpolyee();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.incidentid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.isincidenttypeaddmode = this.loginService.fnCheckUserRoleAction("IncidentType", 'CREATE')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.incidentform.setValue({
      incidentid: 0,
      empid: null,
      incidenttypeid: null,
      transdt: new Date(),
      descr: '',
      actiontaken: '',
      actiontakenby: null,
      actiontakenon: null,
      inactive: false
    })
  }

  fngetIncidentType() {
    var data = {
      'incidenttypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getIncidentType(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.incidenttypeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetEmpolyee() {
    this.isemploading = true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading = false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading = false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetIncident() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'incidentsid': this.incidentid,
      'companyid': this.loginService.fnGetCompanyId()
    }

    console.log(data)
    this.appService.getIncident(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.incidentColl = res.json().result;

            var editdata = this.incidentColl[0];
            this.fnEditMode(editdata);
            this.incidentBO = editdata;
            console.log(this.incidentBO)
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }


  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.incidentform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }
  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.incidentform.get('actiontakenon'))) {
        this.incidentform.controls['actiontakenon'].setErrors(null);
      }

      //Validate
      if (this.incidentform.valid) {

        if (this.incidentform.get('actiontakenon').value) {
          if (this.loginService.fnCheckFornControlNotfound(this.incidentform.get('actiontakenon').value), this.incidentform.get('transdt')) {
            this.incidentform.controls['actiontakenon'].setErrors({ 'notfound': true })
            return;
          }
        }



        this.saveloading = true;
        //Check
        var data = {
          'incidentsid': this.incidentid,
          'transdt': this.fnFormatDatetime(this.incidentform.get('transdt').value),
          'actiontakenon': this.fnFormatDatetime(this.incidentform.get('actiontakenon').value),
          'empid': this.incidentform.get('empid').value,
          'incidenttypeid': this.incidentform.get('incidenttypeid').value,
          'descr': this.incidentform.get('descr').value,
          'actiontaken': this.incidentform.get('actiontaken').value,
          'actiontakenby': this.incidentform.get('actiontakenby').value,
          'inactive': this.incidentform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.incidentform.get('incidentid').value > 0) {
          //Update 
          this.fnSetIncident(data);
        }
        else {
          //Insert 
          this.fnInsertIncident(data);
        }


      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertIncident(data) {

    this.appService.fnInsertIncident(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new incident has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));


            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].incidentid);
            }

          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetIncident(data) {

    this.appService.fnSetIncident(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The incident has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.incidentid, this.fngetDescriptionRefno(data));
            //this.ismanualclose = true;
            // this.fnCloseForm();
            this.fnEditFormEdit(this.incidentid);
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //AddExpenseType
  private fnAddIncidentType() {

    const modalRef = this.productFindService.open(AddincidenttypepopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetIncidentType();

      if (receivedEntry > 0) {
        this.incidentform.patchValue({ incidenttypeid: receivedEntry })
      }
    });

  }
  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }
  fnEditFormEdit(id) {

    this.incidentid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
      'incidenttypeid': this.filterincidenttypeid,
      'incidenttypename': this.filterincidenttypename,
    }

    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });

  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
          'incidenttypeid': this.filterincidenttypeid,
          'incidenttypename': this.filterincidenttypename,
        }
      }

      this.router.navigate(['/Incident'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  private fnEditMode(deptBO) {

    deptBO.transdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.transdt));
    deptBO.actiontakenon = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.actiontakenon));

    this.incidentform.setValue({
      incidentid: deptBO.incidentid,
      empid: deptBO.empid,
      incidenttypeid: deptBO.incidenttypeid,
      transdt: deptBO.transdt,
      descr: deptBO.descr,
      actiontaken: deptBO.actiontaken,
      actiontakenby: deptBO.actiontakenby,
      actiontakenon: deptBO.actiontakenon,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;
    this.fnChangeEmpLookup();
  }
  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.incidentid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetIncident();
      }
    });

    // this.attachmentbar.formtype = this.formname;
    // this.attachmentbar.trxid = this.payadvid;

    // if (this.payadvid > 0) {
    //   this.attachmentbar.formmode = "EDIT";
    // }
    // else {
    //   this.attachmentbar.formmode = "ADD";
    // }

    // this.attachmentbar.fnGetAttachment();

    // this.isshowattachment = !this.isshowattachment

  }


  fnAttachmentSave(tid) {

    // if (this.attachmentcount > 0) {

    //   this.attachmentbar.formtype = this.formname;
    //   this.attachmentbar.trxid = tid;
    //   this.attachmentbar.formmode = "ADD";

    //   this.attachmentbar.fnSaveAttachmentByAddMode();
    // }
    // else {
    //   this.fnCloseForm();
    // }

  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }

  fnAddActivity() {

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.incidentid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

  }

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }

  private fnShowErrorMsg(ex) {
    console.log(ex)
    this.toastr.warning('Internal Error', ex);
  }







}
